import { APIType } from "node_js/models/enums/api-type";

export const environment = {
  production: true,
  apiType: APIType.PROD,
  apiUrl: "https://cloud.api.brilliantlabs.ca",
  siteUrl: "https://cloud.brilliantlabs.ca",
  firebase: {
    apiKey: "AIzaSyD4iyqdGGe8b9p9lefIn8YU3bXuSSSwhVM",
    authDomain: "cloudproduction-f60fb.firebaseapp.com",
    projectId: "cloudproduction-f60fb",
    storageBucket: "cloudproduction-f60fb.firebasestorage.app",
    messagingSenderId: "766565722329",
    appId: "1:766565722329:web:a5fa29f1a52c936cf6b6c8",
    measurementId: "G-348NP5FRQ4"
  },
  // OAuth Client IDs for social sign-in by platform
  oauth: {
    google: {
      web: "766565722329-orffffj9h96b6m4lnbc4sd29t52uvs38.apps.googleusercontent.com",
      android: "766565722329-orffffj9h96b6m4lnbc4sd29t52uvs38.apps.googleusercontent.com",
      ios: "766565722329-6b88aidrlprmf76r9ia1mpliaikg3976.apps.googleusercontent.com"
    },
    facebook: {
      web: "YOUR_WEB_FACEBOOK_APP_ID",
      android: "YOUR_ANDROID_FACEBOOK_APP_ID",
      ios: "YOUR_IOS_FACEBOOK_APP_ID"
    }
  },
  // OAuth redirect URIs for each platform
  oauthRedirects: {
    web: "https://cloud.brilliantlabs.ca",
    android: "com.brilliant_labs.cloud://oauth2redirect",
    ios: "com.brilliantlabs.cloud://oauth2redirect"
  }
};
